<template>
  <main class="main bg-profile">
    <ProfileUser/>
    <ProfileNav :tabs="tabs"/>
    <section class="pt-2">
      <div class="container">
        <div class="tab-content">
          <router-view></router-view>
        </div>
      </div>
    </section>
    <ProfileModalAvatar ref="ProfileModalAvatar"/>
    <ProfileModalCity @getModalCity="modalCity(city)"/>
  </main>
</template>

<script>
  import ProfileUser from "../components/profile/ProfileUser";
  import ProfileNav from "../components/profile/ProfileNav";
  import ProfileVacancy from "../components/profile/ProfileVacancy";
  import ProfileTask from "../components/profile/ProfileTask";
  import ProfilePayment from "../components/profile/ProfilePayment";
  import ProfileInvited from "../components/profile/ProfileInvited";
  import ProfileConfig from "../components/profile/ProfileConfig";
  import ProfileModalAvatar from "../components/profile/ProfileModalAvatar";
  import ProfileModalCity from "../components/profile/ProfileModalCity";
  import ProfileResume from "../components/profile/ProfileResume";

  export default {
    name: "Profile",
    components: {
      ProfileModalCity,
      ProfileModalAvatar,
      ProfileConfig, ProfileInvited, ProfilePayment, ProfileTask, ProfileVacancy, ProfileNav, ProfileUser, ProfileResume},
    data() {
      return {
        tabs: [
          {
            name: 'Вакансии',
            href: '/profile'
          },
          // {
          //   name: 'Задания',
          //   href: 'task-job'
          // },
          {
            name: 'Выплаты',
            href: '/profile/payment'
          },
          {
            name: 'Приглашенные',
            href: '/profile/invited'
          },
          {
            name: 'Резюме',
            href: '/profile/resume'
          },
          {
            name: 'Настройки',
            href: '/profile/config'
          }
        ],
        data: {},
        city: ''
      }
    },
  }
</script>

<style>
  .bg-profile {
    background-color: #f8f8f8;
  }
</style>
